import { __awaiter, __generator } from "tslib";
import { IDBEngineCursor } from './cursor';
var IDBEngineIndex = /** @class */ (function () {
    function IDBEngineIndex(table, proxyIndex, mode, engineAspects) {
        this.table = table;
        this.proxyIndex = proxyIndex;
        this.mode = mode;
        this.engineAspects = engineAspects;
        this.name = proxyIndex.name;
        this.keyPath = proxyIndex.keyPath;
        this.unique = proxyIndex.unique;
        if (engineAspects === null || engineAspects === void 0 ? void 0 : engineAspects.index) {
            this.applyAspectPatch();
        }
    }
    IDBEngineIndex.prototype.getAll = function (query) {
        return this.proxyIndex.getAll(query);
    };
    IDBEngineIndex.prototype.getAllKeys = function (query, count) {
        return this.proxyIndex.getAllKeys(query, count);
    };
    IDBEngineIndex.prototype.get = function (query) {
        return this.proxyIndex.get(query);
    };
    IDBEngineIndex.prototype.openCursor = function (query, direction) {
        return __awaiter(this, void 0, void 0, function () {
            var proxyCursor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.proxyIndex.openCursor(query, direction)];
                    case 1:
                        proxyCursor = _a.sent();
                        if (!proxyCursor) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, new IDBEngineCursor(this.mode, proxyCursor, direction !== null && direction !== void 0 ? direction : 'next')];
                }
            });
        });
    };
    /**
     * bind the hook stub to the index object
     */
    IDBEngineIndex.prototype.applyAspectPatch = function () {
        var _a;
        var indexAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.index;
        var hookTarget = this;
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.get.patch(hookTarget, 'get');
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.getAll.patch(hookTarget, 'getAll');
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.getAllKeys.patch(hookTarget, 'getAllKeys');
        indexAspects === null || indexAspects === void 0 ? void 0 : indexAspects.openCursor.patch(hookTarget, 'openCursor');
    };
    return IDBEngineIndex;
}());
export { IDBEngineIndex };
//# sourceMappingURL=database-index.js.map